import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useLoginCookie from "shared/model/useLoginCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAuthLogin = (idRef, pwRef) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setLoginCookie] = useLoginCookie()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("POST", "/auth/login", {
            "id": idRef?.current?.value.trim(),
            "password": pwRef?.current?.value.trim()
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setLoginCookie(fetchResult?.data?.token)
                navigate("/", { "replace": true })
                break
            case 400:
                if (fetchResult?.data?.error_code === "id") setAlert("아이디 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "password") setAlert("비밀번호 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) setAlert("사용이 정지된 계정입니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("등록되지 않은 아이디 이거나\n아이디 또는 비밀번호를 잘못 입력하였습니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostAuthLogin